import { Injectable } from "@angular/core";
import { CustomCookieService } from './mycookie.service';
import { JSONP_HOME } from "@angular/http/src/backends/browser_jsonp";
import { Http } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Observer } from "rxjs/Observer";
import { Response, RequestOptions, Headers } from '@angular/http';
import { CustomStorage } from "./Custom-storage.service";
import { environment } from '../../environments/environment';
import { Constant } from '../Constant'

@Injectable()
export class LanguageService {

    language_key = Constant.KEY_CDISELECTEDLANGUAGE;

    commonurl: string = environment.commonurl;
    private app_data: any;
    private username: string = "staticuser";
    private password: string = "s3cur1ty";
    constructor(private cookie: CustomCookieService, private http: Http, private localStorage: CustomStorage) {
        // this.getLanguageData();
    }

    setLanguageData(languageId): any {

        return new Promise<any>(res => {            
            this.saveLiterals(languageId).then(data => {
                res(true);
            });
        });
    }

    saveLiterals(languageValue) {
        this.cookie.setCookieData(this.language_key, languageValue);
        return new Promise(data => {
            this.getJson().subscribe(jsonData => {
                let ttLanguages = jsonData.data.setup_info;
                var languages = [];
                for (var i = 0; i < ttLanguages.length; i++) {
                    var obj = ttLanguages[i];
                    if (languageValue === obj.languageId) {
                        this.localStorage.setItem(Constant.KEY_LITERALS, obj.literals).subscribe(res => {
                            data(true);
                        });
                    }
                    else if (i === ttLanguages.length - 1) {
                        this.localStorage.setItem(Constant.KEY_LITERALS, ttLanguages[0].literals).subscribe(res => {
                            data(true);
                        });
                    }
                }
            });
        });
    }

    getLangLabel(languageLabel): any {

        return new Promise(res => {
            this.localStorage.getItem(Constant.KEY_LITERALS).subscribe(data => {
                
                if (data === null) {
                    let cookieValue = '0';
                    if (this.cookie.getCookieData(this.language_key) != "")
                        cookieValue = this.cookie.getCookieData(this.language_key);
                    this.saveLiterals(cookieValue).then(resp => {
                        //this.getLangLabel(languageLabel);
                        this.localStorage.getItem(Constant.KEY_LITERALS).subscribe(data => {
                            res(data[languageLabel]);
                        });
                    });
                } else {
                    res(data[languageLabel]);
                }
            })
        });
    }

    async getLangLabelValue(languageLabel): Promise<string> {
        
        return new Promise<string>(ret => {

            this.localStorage.getItem(Constant.KEY_LITERALS).subscribe(data => {
                if (data === null) {
                    let cookieValue = '0';
                    if (this.cookie.getCookieData(this.language_key) != "")
                        cookieValue = this.cookie.getCookieData(this.language_key);
                    this.saveLiterals(cookieValue).then(resp => {
                        //this.getLangLabel(languageLabel);                        
                        this.localStorage.getItem(Constant.KEY_LITERALS).subscribe(data => {
                            ret(data[languageLabel]);
                        });
                    });
                } else {
                    ret(data[languageLabel]);
                }
            })
        });

        
    }

    getAllLanguages(): Observable<any> {
        return Observable.create((observer: Observer<any>) => {
            this.getJson().subscribe((jsonData) => {
                let ttLanguages = jsonData.data.setup_info;
                var languages = [];
                for (var i = 0; i < ttLanguages.length; i++) {
                    var obj = ttLanguages[i];
                    var langObj = {};
                    langObj['languageName'] = obj.languageName;
                    langObj['languageId'] = obj.languageId;
                    languages.push(langObj);
                }
                observer.next(languages);
            }, (error) => {
                observer.error(error);
            },
                () => {
                    observer.complete();
                }
            );
        });
    }



    getLanguageData() {
        return Observable.create((observer: Observer<any>) => {

            let headers = new Headers();
            //headers.append("Authorization", "Basic " + btoa(this.username + ":" + this.password));

            let options = new RequestOptions({
                headers: headers
            });

            let url = this.commonurl + "systemsetup";
            this.http.get(url, options).subscribe(
                res => {
                    //this.cookie.setCookieData("languageData", res);
                    let resp = res.json().response;
                    if( resp != null )
                    this.localStorage.setItem(Constant.KEY_LANGUAGE, res.json().response).subscribe(data => {
                        observer.next(true);
                        observer.complete();
                    });
                },
                error => {
                    this.localStorage.getItem(Constant.KEY_LANGUAGE).subscribe(data => {

                        if(data != null){
                            observer.next(data);
                            observer.complete();
                        }else{
                            observer.error(error);
                            observer.complete();
        
                        }
                    });
                },
                () => {

                });
        });
    }

    getJson() {
        return this.localStorage.getItem('language');
    }

    public getAllCompanies(): Observable<any> {
        return Observable.create((observer: Observer<any>) => {

            this.getJson().subscribe(jsonData => {

                let ttCompanies = jsonData.companies.company;
                observer.next(ttCompanies);
                observer.complete();
            });
        });

    }
    getCurrentCompany(): Observable<any>{
        return Observable.create((observer: Observer<any>) => {
            this.getAllCompanies().subscribe( data => {
            for(let company of data){
                let userName = this.cookie.getCookieData(Constant.KEY_USERNAME);
                if(userName.toLowerCase().startsWith(company['companyCode'].toLowerCase())){
                    
                    observer.next(company);
                    observer.complete();
                    return;
                }
            }
        });
    });
    }

    getSelectedLanguage(region:string = ""): Observable<any> {
        return Observable.create((observer: Observer<any>) => {
            let languageValue = this.cookie.getCookieData(this.language_key);
             if(languageValue == null || languageValue.length ==  0){
                languageValue = region;
                console.log("languagevalue is"+languageValue)
                this.saveLiterals(languageValue)
            }
            // console.log(this);
            this.getJson().subscribe(jsonData => {
                let ttLanguages = jsonData.data.setup_info;
                var languages = [];
                for (var i = 0; i < ttLanguages.length; i++) {
                    var obj = ttLanguages[i];
                    var langObj = {};
                    langObj['languageName'] = obj.languageName;
                    langObj['languageId'] = obj.languageId;
                    if (languageValue === obj.languageId) {
                        languages.push(langObj);
                        observer.next(languages);
                        observer.complete();                        
                        return;
                    }

                    else if (i === ttLanguages.length - 1) {
                        var obj = ttLanguages[0];
                        var langObj = {};
                        langObj['languageName'] = obj.languageName;
                        langObj['languageId'] = obj.languageId;
                        this.saveLiterals(obj.languageId).then(data => {
                            languages.push(langObj);
                            observer.next(languages);
                            observer.complete();

                        });
                    }
                }


            });


        });
    }

}


// WEBPACK FOOTER //
// ./src/app/providers/lang.service.ts